import { Component, DoCheck, OnInit } from '@angular/core';
import {select, Store} from "@ngrx/store";
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { Dashboard } from 'src/app/state/dashboard';
import { invokeDashboardAPI } from 'src/app/state/dashboard.action';
import { DashboardSelector } from 'src/app/state/dashboard.selector';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit,DoCheck  {

  books$: Observable<Dashboard> = this.store.pipe(select(DashboardSelector));
  public dataChartTenYears: Object
  public currency: string;
  public user:any;

  constructor(private appService: AppService,
              private store: Store) {}

  
  ngOnInit(): void {
    this.store.dispatch(invokeDashboardAPI());
    this.currency = this.appService.getCurrency();
    this.initData()
  }

  initData()
  {
    const storageAuth = localStorage.getItem("user");
    this.user = JSON.parse(storageAuth!);
  }

  ngDoCheck(){
    this.initData()
  }

}
